export const ROUTES = {
  ROOT: '/shipment/return',
};
